import script from "./DataList.vue?vue&type=script&setup=true&lang=js"
export * from "./DataList.vue?vue&type=script&setup=true&lang=js"

import "./DataList.vue?vue&type=style&index=0&id=07ebc46e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ebc46e"]])

export default __exports__